import React from 'react';
import { Button, Confirm } from 'semantic-ui-react';

// @props: name, type, open, closeModal, onClick

const TermInactiveConfirmModal = props => {
	return (
		<Confirm
			className="term-inactive-confirm-modal"
			open={ props.open }
			size="tiny"
			header={ `Restore ${ props.type } As Lead?` }
			content={
				<div className="content" style={{ fontSize: '16px' }}>
          Are you sure you want to restore <strong>{ props.name || `this ${ props.type.toLowerCase() }` }</strong> as a lead?
					{ props.message }
				</div>
			}
			cancelButton="Cancel"
			confirmButton={ () => (
				<Button
					negative
					onClick={ () => {
						props.onClick();
						props.closeModal();
					} }
				>
          Restore
				</Button>
			) }
			onCancel={ props.closeModal }
		/>
	);
};

export default TermInactiveConfirmModal;
